import { render } from "./Panel.vue?vue&type=template&id=484f49fe"
import script from "./Panel.vue?vue&type=script&lang=ts"
export * from "./Panel.vue?vue&type=script&lang=ts"
script.render = render

export default script